// extracted by mini-css-extract-plugin
export default {"submenuContent":"src-hellospa-components-global-header-menu-walkthrough-module__submenuContent--2cCue"};